import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePlatformStore = defineStore('platform', () => {
  const alertBannerHeight = ref(0)
  const isSidebarCollapsed = ref(false)
  const locale = ref('en-US')

  const setAlertBannerHeight = (height: number) => {
    alertBannerHeight.value = height
  }

  const setSidebarCollapse = (value: boolean) => {
    isSidebarCollapsed.value = value
  }

  const toggleSidebarCollapse = () => {
    isSidebarCollapsed.value = !isSidebarCollapsed.value
  }

  const setLocale = (value: string) => {
    locale.value = value
  }

  return {
    alertBannerHeight,
    setAlertBannerHeight,
    isSidebarCollapsed,
    setSidebarCollapse,
    toggleSidebarCollapse,
    locale,
    setLocale,
  }
})
